/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export default makeStyles()(theme => ({
  root: {
    color: theme.palette.text.primary,
    borderRadius: Tokens.spacing['$sp-0'],
    borderBottom: Tokens.spacing['$sp-0']
  },
  title: {
    padding: Tokens.spacing['$sp-1-5'],
    width: 'auto',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflowX: 'hidden'
  }
}));
